import chips from "../../public/locales/en/chips.json";
import common from "../../public/locales/en/common.json";
import dreamTeam from "../../public/locales/en/dreamTeam.json";
import entryHistory from "../../public/locales/en/entryHistory.json";
import fixturesAndFDR from "../../public/locales/en/fixturesAndFDR.json";
import help from "../../public/locales/en/help.json";
import home from "../../public/locales/en/home.json";
import leaguesAndCups from "../../public/locales/en/leaguesAndCups.json";
import onboarding from "../../public/locales/en/onboarding.json";
import pickTeam from "../../public/locales/en/pickTeam.json";
import plos from "../../public/locales/en/plos.json";
import points from "../../public/locales/en/points.json";
import priceChanges from "../../public/locales/en/priceChanges.json";
import prizes from "../../public/locales/en/prizes.json";
import rules from "../../public/locales/en/rules.json";
import scout from "../../public/locales/en/scout.json";
import squad from "../../public/locales/en/squad.json";
import statistics from "../../public/locales/en/statistics.json";
import status from "../../public/locales/en/status.json";
import transfers from "../../public/locales/en/transfers.json";
import winnerDetails from "../../public/locales/en/winnerDetails.json";

export const enNamespaces = {
  chips,
  common,
  dreamTeam,
  entryHistory,
  fixturesAndFDR,
  help,
  home,
  leaguesAndCups,
  onboarding,
  pickTeam,
  plos,
  points,
  priceChanges,
  prizes,
  rules,
  scout,
  squad,
  statistics,
  status,
  transfers,
  winnerDetails,
};

export type Namespace = keyof typeof enNamespaces;
export const namespaces = Object.keys(enNamespaces) as Namespace[];
export const resources = {
  en: enNamespaces,
} as const;
